// extracted by mini-css-extract-plugin
export default {"root":"_2QxM9","traded":"_5weNB","icon":"_2TXHd","warning":"_3pQoe"};